import { createSelector } from 'reselect';
import * as SimpleDate from 'foundations-components/transitional/utils/SimpleDate';
import * as DateRangePresets from 'foundations-components/transitional/components/Dates';
import { getContainerTypeFilter, getCurrentDateRangeWithDefaults, getFilterByState, getSearchQuery, getSelectedCampaign } from './filterSelectors';
import { getFrequency as getAnalyzeFrequency, getView as getAnalyzeView } from './analyze';
import { getCurrentPathParams } from './appStateSelectors';
import { DEFAULT_PARAMS } from 'web-interactives-dashboard-ui/reducers/analyze';
import { getFromCampaignId } from '../utils/urls';
const QUERY_DATE_FORMAT = 'YYYY-MM-DD';
export const getPathParams = createSelector(getFilterByState, getCurrentPathParams, (stateFilter, currentPathParams) => {
  if (currentPathParams.includes('manage') && stateFilter) {
    return ['manage', 'state', stateFilter.toLowerCase()];
  }
  return currentPathParams;
});
const getSearchQueryString = createSelector(getSearchQuery, query => query && `query=${query}`);
const getDateQueryString = createSelector(getCurrentDateRangeWithDefaults, ({
  startDate,
  endDate,
  presetId
}) => {
  if (presetId) {
    if (presetId !== DateRangePresets.LAST_THIRTY_DAYS.presetId) {
      return `dateType=${presetId}`;
    }
  } else {
    const startDateInt = SimpleDate.toFormattedString(startDate, QUERY_DATE_FORMAT);
    const endDateInt = SimpleDate.toFormattedString(endDate, QUERY_DATE_FORMAT);
    return [`startDate=${startDateInt}`, `endDate=${endDateInt}`];
  }
});
const getContainerType = createSelector(getContainerTypeFilter, containerType => containerType && `containerType=${containerType}`);
const getCampaignId = createSelector(getSelectedCampaign, campaignId => campaignId && `campaignId=${campaignId}`);
const getFrequency = createSelector(getAnalyzeFrequency, frequency => frequency && frequency !== DEFAULT_PARAMS.frequency && `frequency=${frequency}`);
const getView = createSelector(getAnalyzeView, view => view && view !== DEFAULT_PARAMS.view && `view=${view}`);
const getQueryParams = createSelector(getSearchQueryString, getDateQueryString, getContainerType, getCampaignId, getFrequency, getView, getFromCampaignId, (...queryParams) => queryParams.flat().filter(Boolean));
export const getUrlQueryString = createSelector(getQueryParams, queryParams => queryParams.length ? `?${queryParams.join('&')}` : '');